import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Paper, Typography } from "@mui/material"
import { buttonStyle, titleStyle } from "../../utils/commonCSS"
import { amber, green, headingBlue, maroon } from "../../assets/colors"
import { Close, Done } from "@mui/icons-material"

const ClosedLeadDetails = (props) => {

    var data= props.data
  return (
    <>
        <Dialog maxWidth={'sm'} fullWidth open={props.dialogStatus} onClose={() => props.updateDialogStatus()}>
            <DialogTitle style={{...titleStyle}}>
                Lead Details
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1} style={{padding: '0.4rem 0.2rem 0.4rem 0.2rem', color: maroon, fontSize: '1rem', marginTop: '0.3rem', fontWeight: 500}}>
                    <Grid item xs={3} sm={3}>
                        {data?.name}
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        {data?.contactNumber}
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        {data?.WORKerName ? data?.WORKerName : '-'}
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        {data?.isAssignedToChapterCaller ? data?.assignedToWORKer : data?.isAssignedToCaller ? data?.assignedTo : 'SMP'}
                    </Grid>
                </Grid>

                {data.templateId != '' ?
                <Paper style={{padding: '0.5rem 0.2rem 0.5rem 0.4rem', marginTop: '0.3rem', border: '1px solid #D9D9D9', color: amber}}>
                    <Typography>Assigned Template: {data?.templateName}</Typography>
                    {data?.fields?.map((option) => {
                        return (
                            <>
                                <Box style={{display: 'flex', flexDirection: 'row', borderBottom: '1px solid #D9D9D9', padding: '0.1rem 0.3rem 0.1rem 0.3rem', marginTop: '0.3rem', color: headingBlue}}>
                                    <Box style={{width: '80%', display: 'flex', justifyContent: 'flex-start'}}>
                                        <Typography>{option.name?.label ? option.name?.label : option.name}</Typography>
                                    </Box>
                                    <Box style={{width: '15%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                                        {option.value ? 
                                            <Done style={{color: green}}></Done>
                                         :
                                            <Close style={{color: maroon}}></Close>
                                        }
                                    </Box>
                                    
                                </Box>
                                
                            </>
                        )

                    })}
                    <Box style={{display: 'flex', flexDirection: 'column', padding: '0.5rem 0.3rem 0.5rem 0.3rem'}}>
                        <Typography>Remarks:</Typography>
                        <Typography style={{padding: '0rem 0.5rem 0rem 0.5rem', color: headingBlue}}>{data.remarks ? data.remarks : 'No Remark'}</Typography>
                    </Box>
                    </Paper>
                :
                <></>
            }
            </DialogContent>

        </Dialog>
    </>
  )
}

export default ClosedLeadDetails
